/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import "./Loader.css"; // Make sure to create this CSS file

const Loader = () => {
  return (
    <div className="loader-container">
      <img
        className="loading-logo"
        src="/assets/images/logo.svg"
        alt="Loading..."
      />
      <span className="text-success">Loading...</span>
    </div>
  );
};

export default Loader;
